import 'jquery-ui';
require('jquery-ui/ui/widgets/autocomplete.js');
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import NiceSelect from 'nice-select2/src/js/nice-select2';

jQuery(function ($) {

    if ($('[data-bs-toggle="tooltip"]').length > 0) {
        $('[data-bs-toggle="tooltip"]').each((index, element) => {
            new bootstrap.Tooltip(element);
        });
    }

    // autocomplete zip input
    let url = $("#zip_station").attr("data-url");
    if ($('#zip_station').length > 0) {
        $('#zip_station').autocomplete({
            source: function (req, response) {
                $.get(
                    url+'?action=zip_station_search',
                    req,
                    response,
                    'json'
                )
            },
            delay: 300,
            minLength: 3
        });
    }

    // groupe particularite précisions hide and show container
    const precisionsInputContainer = $('#groupe_particularite_precisions');
    const updatePrecisionsInputDisplay = element => {
        if (element.val() === '1') {
            precisionsInputContainer.removeClass('d-none');
        } else if (element.val() === '0') {
            precisionsInputContainer.addClass('d-none');
        }
    }

    const particulariteInput = $('input[name="groupe[particularite][choice]"]');
    if (particulariteInput.length > 0 && precisionsInputContainer.length > 0) {
        updatePrecisionsInputDisplay(precisionsInputContainer);
        particulariteInput.change(function () {
            updatePrecisionsInputDisplay($(this));
        });
    }
    
    /********************* COLLECTION DATES FORM STATION ******************/
    if ($('#form_station_step_5').length > 0) {

        const date_collection_adder = $('#add_date_item');
        const date_collection_container = $('#date_visite_prototype_container');
        date_collection_adder.click(function () {
            const prototype = date_collection_container.attr('data-prototype');
            let index = date_collection_container.attr('data-index');
            const newItem = prototype.replace(/__index__/g, index);
            date_collection_container.append(newItem);
            new NiceSelect($(`#date_collection_${index}_horaire`)[0], {searchable: false});
            index++;
            date_collection_container.attr('data-index', index);
        });
        
        $(document).on('click', '.date_collection_remover', function () {
            const item = $(this).closest('.date_collection_item');
            item.fadeOut(200, () => {
                item.remove();
            })
        });

    }
    /********************* COLLECTION DATES FORM STATION ******************/
});
